import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateCashBalance } from '../cashApi';

/** Set one currency's cash balance (and/or its margin rate). */
export function useUpdateCashBalance() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCashBalance,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['positions'] });
      queryClient.invalidateQueries({ queryKey: ['position'] });
      queryClient.invalidateQueries({ queryKey: ['portfolioTotal'] });
    },
  });
}
